import { TextField, TextFieldProps } from "@mui/material";
import Flex from "./Flex";
import { inputLabel } from "./MaskInput";
import { useFieldLock } from "./ReadOnlyFields";
import Text from "./Text";
import { DEFAULT_FONTSIZE } from "../utils/utils";

type CustomTextAreaProps = {
  minRows?: number;
  label?: string;
  required?: boolean;
} & TextFieldProps;

export default function CustomTextArea({
  label,
  required,
  minRows,
  ...others
}: CustomTextAreaProps) {
  const lock = useFieldLock(others.disabled);

  return (
    <Flex width={"100%"} flexDirection={"column"}>
      {/* <Typography mb={"10px"} sx={DEFAULT_FONTSIZE}>
        {label}
        {others.required && (
          <Typography component={"span"} color={"error"}>{` *`}</Typography>
        )}
      </Typography> */}

      <Flex flexDirection={"column"} gap={1} width={"100%"}>
        <TextField
          sx={{
            "& .MuiInputBase-input": { ...DEFAULT_FONTSIZE },
          }}
          label={inputLabel(label, required)}
          multiline={others.multiline ?? true}
          InputLabelProps={{ shrink: true }}
          fullWidth
          rows={minRows}
          {...others}
          disabled={lock.disabled}
          InputProps={{
            ...others.InputProps,
            readOnly: lock.readOnly || !!others.InputProps?.readOnly,
          }}
        />

        {!!others?.error && (
          <Text fontSize={"13px"} variant="caption" color="error">
            {others.error}
          </Text>
        )}
      </Flex>
    </Flex>
  );
}
